// extracted by mini-css-extract-plugin
module.exports = {"divisions":"DivisionsScreen_divisions__P8WxN","left":"DivisionsScreen_left__1zagB"};